import React from 'react'
import Modal from "react-bootstrap/Modal";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ErrorMessage = ({ Show, errorMessage, ErrorDoneClick } ) => {
    
    if (!errorMessage) {
        return null;
      }
    
      const renderValidationErrors = () => {
        return errorMessage.errors && Object.entries(errorMessage.errors).map(([key, value]) => (
          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12" key={key}>
            <h6>{key}</h6>
            {value?.map((item, index) => (
              <p key={index}>{item}</p>
            ))}
          </div>
        ));
      };


      const renderApiError = () => (
     
        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <h6>Error</h6>
            {errorMessage?.errors.map((error, index) => (
                <h6 key={index}><p> {error.message}</p></h6>))}
        </div>
    );

    
    return (
        <Modal size='md' show={Show} centered className="commonErrorMessageModal">
            <Modal.Header>
                <div className="">
                    <h5><i class="fas fa-exclamation-triangle"></i> This page contains following errors</h5>
                </div>
                <div className="">
                    <i className="fas fa-times" onClick={ErrorDoneClick}></i>
                </div>
            </Modal.Header>
            <Modal.Body>

                <div className="row">
                    {/* {errorMessage.errors && Object.entries(errorMessage.errors).map(([key, value]) => {
                        return (
                            <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <h6>{key}</h6>
                                {value?.length > 0 ? (
                                    value?.map((item, index) => {
                                        return <p key={index}>{item}</p>;
                                    })
                                ) : (
                                    ""
                                )}
                            </div>
                        );
                    })} */}
               {!Array.isArray(errorMessage.errors) ? renderValidationErrors() : renderApiError()}


                </div>

                <Modal.Footer>
                    <button type="button" class="btn ok-btn" data-dismiss="modal" onClick={ErrorDoneClick}>OK</button>
                </Modal.Footer>

            </Modal.Body>
        </Modal>
    )
}

export default ErrorMessage